import React, { Component, Fragment } from 'react';
import { Button, Form, Loader, Popup, Segment } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import { DateTimePicker } from 'react-widgets';
import { fetchAcademicYears, fetchAllAcademicYears, fetchStudyCycle, fetchStudyType } from '../../Lookups/util';
import axios from 'axios';
import { toast } from 'react-toastify';

class RegistrationLinkForm extends Component {
    constructor(props, context) {
        super();

        this.state = {
            link: props.link || {},
            saving: false,
            onCloseForm: props.onCloseForm || (() => {
            }),
            onRefreshData: props.onRefreshData || (() => {
            }),

            mobilityProgramOptions: [],
            studyTypeOptions: [],
            mobilityTypeOptions: [],
            mobilityFormatOptions: [],
            academicYearOptions: [],
            semesterOptions: [],
            fieldOfEducationOptions: [],
            studyProgramOptions: [],
            nonCycleProgramOptions: [],
            loadingOptions: true,

            errors: {},
        };
    }

    onChangeLink = (updatedFields) => {
        this.setState((prevState) => ({
            link: {
                ...prevState.link,
                ...updatedFields
            }
        }));
    };

    componentDidMount() {
        const localStorageRole = localStorage.getItem('activeRole') || '';
        const isStudentService = localStorageRole.slice(0, 10) === 'Studentska';
        const { link } = this.state;
        const facultyId = link.organizationalUnit ? link.organizationalUnit.id : null;

        // Studentska služba resolves its own faculty server-side; other roles (e.g. Administrator)
        // aren't tied to a single organizational unit, so the faculty must be passed explicitly -
        // taken from the link being edited.
        const studyProgramsRequest = (!isStudentService && facultyId)
            ? axios.get(`/study-programs/dto-by-faculty/for-admin/${facultyId}`)
            : axios.get('/study-programs/dto-by-faculty');

        Promise.all([
            fetchStudyCycle(),
            axios.get('/mobility-programs'),
            fetchAcademicYears(),
            axios.get('/field-of-education'),
            axios.get('/mobility-formats'),
            fetchStudyType(),
            axios.get('/external-student-semesters'),
            axios.get('/mobility-types'),
            studyProgramsRequest,
            axios.get('/non-cycle-programs'),
        ])
            .then(([cycles, mobilityPrograms, academicYears, fieldOfEducations, mobilityFormats, studyTypes, externalStudentSemesters, mobilityTypes, studyPrograms, nonCyclePrograms]) => {
                let filteredStudyPrograms = studyPrograms.data.filter(sp =>
                    sp.studyProgram &&
                    sp.studyProgram.name &&
                    sp.studyProgram.name.trim() !== '' &&
                    sp.studyProgram.studyProgramStatus &&
                    sp.studyProgram.studyProgramBasic &&
                    sp.studyProgram.studyProgramBasic.name &&
                    sp.studyProgram.studyProgramBasic.name.trim() !== '' &&
                    (sp.studyProgram.studyProgramStatus.id === 1 || sp.studyProgram.studyProgramStatus.id === 2)
                );
                let studyProgramOptions = filteredStudyPrograms.map(sp => {
                    const studyCycles = (sp.studyCycles && sp.studyCycles.length)
                        ? sp.studyCycles
                        : (sp.studyProgram.studyCycles || []);

                    const studyCyclesText = studyCycles.length
                        ? ' | ' + studyCycles.map(sc => sc.name)
                        .join(', ')
                        : '';

                    const descriptionText = sp.studyProgram.description
                        ? ' | ' + sp.studyProgram.description
                        : '';

                    return {
                        key: sp.studyProgram.id,
                        value: sp.studyProgram,
                        text: sp.studyProgram.studyProgramBasic.name.trim() + ' - ' + sp.studyProgram.name.trim()
                            + studyCyclesText
                            + descriptionText,
                        description: sp.studyProgram.studyProgramBasic.comment,
                    };
                });
                this.setState({
                    studyCycleOptions: cycles.data.map(s => ({
                        key: s.id,
                        value: s,
                        text: s.name
                    })),
                    mobilityProgramOptions: mobilityPrograms.data.map(e => ({
                        key: e.id,
                        value: e,
                        text: e.name
                    })),
                    fieldOfEducationOptions: fieldOfEducations.data.map(f => ({
                        key: f.id,
                        value: f,
                        text: f.name + ' | ' + f.code
                    }))
                        .sort((a, b) => b.text.localeCompare(a.text)),
                    academicYearOptions: academicYears.data.map(a => ({
                        key: a.id,
                        value: a,
                        text: a.name
                    }))
                        .sort((a, b) => b.text.localeCompare(a.text)),
                    mobilityFormatOptions: mobilityFormats.data.map(m => ({
                        key: m.id,
                        value: m,
                        text: m.name
                    })),
                    studyTypeOptions: studyTypes.data.map(s => ({
                        key: s.id,
                        value: s,
                        text: s.name
                    })),
                    semesterOptions: externalStudentSemesters.data.map(e => ({
                        key: e.id,
                        value: e,
                        text: e.name
                    })),
                    mobilityTypeOptions: mobilityTypes.data.map(m => ({
                        key: m.id,
                        value: m,
                        text: m.name
                    })),
                    studyProgramOptions,
                    nonCycleProgramOptions: nonCyclePrograms.data.map(p => ({
                        key: p.id,
                        value: p,
                        text: p.programName,
                        description: ((window.$locale !== 'bs' && p.nonCycleStudyProgramType.translations.length) ? p.nonCycleStudyProgramType.translations.find(e => e.language === window.$locale).name : p.nonCycleStudyProgramType.name),
                    })),
                }, () => {
                    const defaultStudyType = studyTypes.data.find(s => s.id === 1);
                    this.onChangeLink({ studyType: defaultStudyType });
                });
                this.setState({ loadingOptions: false });
            })
            .catch(err => {
                this.setState({ loadingOptions: false });
                toast('Došlo je do greške! Podaci za formu nisu učitani.');
            });
    }

    handleSubmit = () => {
        const isEditing = this.props.link;

        this.setState({ saving: true }, () => {
            const {
                link
            } = this.state;

            const body = {
                id: link.id || null,
                organizationalUnitId: link.organizationalUnit ? link.organizationalUnit.id : null,
                mobilityProgramId: link.mobilityProgram ? link.mobilityProgram.id : null,
                mobilityTypeId: link.mobilityType ? link.mobilityType.id : null,
                mobilityFormatId: link.mobilityFormat ? link.mobilityFormat.id : null,
                academicYearId: link.academicYear ? link.academicYear.id : null,
                semesterId: link.semester ? link.semester.id : null,
                fieldOfEducationId: link.fieldOfEducation ? link.fieldOfEducation.id : null,
                studyProgramId: link.studyProgram ? link.studyProgram.id : null,
                nonCycleProgramId: link.nonCycleProgram ? link.nonCycleProgram.id : null,
                expiresAt: link.expiresAt || null,
            };

            // validation:
            const errors = {
                mobilityProgramErr: !body.mobilityProgramId,
                mobilityFormatErr: !body.mobilityFormatId,
                academicYearErr: !body.academicYearId,
                fieldOfEducationErr: !body.fieldOfEducationId,
                mobilityTypeErr: !body.mobilityTypeId,
                semesterErr: body.mobilityTypeId && link.mobilityType._key === 'cycle' && !body.semesterId,
                studyProgramErr: body.mobilityTypeId && link.mobilityType._key === 'cycle' && !body.studyProgramId,
                nonCycleProgramErr: body.mobilityTypeId && link.mobilityType._key === 'non_cycle' && !body.nonCycleProgramId,
                expiresAtErr: false
            };

            const hasError = Object.values(errors)
                .some(e => e);
            if (hasError) {
                this.setState({
                    errors,
                    saving: false
                });
                toast(<FormattedMessage id="externalStudent.toast.fillRequiredFields"/>);
                return;
            }

            const apiCall = isEditing
                ? axios.put(`/external-student-registration-link/`, body)
                : axios.post('/external-student-registration-link/', body);

            apiCall
                .then(() => {
                    this.setState({ saving: false });
                    this.state.onCloseForm();
                    this.state.onRefreshData();
                    toast(isEditing
                        ? <FormattedMessage id="externalStudent.toast.registrationLinkEdited"/>
                        : <FormattedMessage id="externalStudent.toast.registrationLinkCreated"/>);
                })
                .catch(() => {
                    this.setState({ saving: false });
                    toast(<FormattedMessage id="externalStudent.toast.saveError"/>);
                });
        });
    };


    render() {
        const {
            mobilityProgramOptions,
            studyTypeOptions,
            mobilityTypeOptions,
            mobilityFormatOptions,
            academicYearOptions,
            semesterOptions,
            fieldOfEducationOptions,
            studyProgramOptions,
            nonCycleProgramOptions,
            loadingOptions,

            errors,
            saving,
            link
        } = this.state;

        return (
            <Segment>
                {loadingOptions ? (
                    <div style={{
                        paddingTop: '100px',
                        paddingBottom: '100px'
                    }}><Loader active inline="centered"/></div>
                ) : (
                    <Segment clearing padded>
                        <Form>
                            <Form.Group widths={'equal'}>
                                <Form.Field required>
                                    <label><FormattedMessage id="externalStudent.mobilityProgram"/></label>
                                    <Form.Dropdown
                                        search
                                        options={mobilityProgramOptions}
                                        value={link.mobilityProgram}
                                        selection
                                        clearable
                                        placeholder={<FormattedMessage id="externalStudent.selectMobilityProgram"/>}
                                        onChange={(e, { value }) => this.onChangeLink({ mobilityProgram: value })}
                                        error={errors.mobilityProgramErr}
                                    />
                                </Form.Field>
                                <Popup
                                    content={
                                        <Fragment>
                                            <b>
                                                <FormattedMessage id="externalStudent.cyclicalStudyProgram"/>: <br/>
                                            </b>
                                            <FormattedMessage
                                                id="externalStudent.mobilityTypeInfoCyclical"/><br/>
                                            <br/>
                                            <b>
                                                <FormattedMessage id="externalStudent.nonCyclicalStudyProgram"/>: <br/>
                                            </b>
                                            <FormattedMessage
                                                id="externalStudent.mobilityTypeInfoNonCyclical"/><br/>
                                        </Fragment>
                                    }
                                    trigger={
                                        <Form.Field required>
                                            <label><FormattedMessage id="externalStudent.mobilityType"/></label>
                                            <Form.Dropdown
                                                search
                                                options={mobilityTypeOptions}
                                                value={link.mobilityType}
                                                selection
                                                clearable
                                                placeholder={<FormattedMessage
                                                    id="externalStudent.selectMobilityType"/>}
                                                onChange={(e, { value }) => this.onChangeLink({ mobilityType: value })}
                                                error={errors.mobilityTypeErr}
                                            />
                                        </Form.Field>
                                    }
                                />
                            </Form.Group>
                            <Form.Group widths={'equal'}>
                                <Form.Field required>
                                    <label><FormattedMessage id="externalStudent.mobilityFormat"/></label>
                                    <Form.Dropdown
                                        search
                                        options={mobilityFormatOptions}
                                        value={link.mobilityFormat}
                                        selection
                                        clearable
                                        placeholder={<FormattedMessage id="externalStudent.selectMobilityFormat"/>}
                                        onChange={(e, { value }) => this.onChangeLink({ mobilityFormat: value })}
                                        error={errors.mobilityFormatErr}
                                    />
                                </Form.Field>
                                <Form.Field required>
                                    <label><FormattedMessage id="externalStudent.academicYear"/></label>
                                    <Form.Dropdown
                                        search
                                        options={academicYearOptions}
                                        value={link.academicYear}
                                        selection
                                        clearable
                                        placeholder={<FormattedMessage id="externalStudent.selectAcademicYear"/>}
                                        onChange={(e, { value }) => {
                                            this.onChangeLink({ academicYear: value });
                                        }}
                                        error={errors.academicYearErr}
                                    />
                                </Form.Field>
                                {link.mobilityType && link.mobilityType._key === 'cycle' &&
                                    <Fragment>
                                        <Form.Field required>
                                            <label><FormattedMessage
                                                id="externalStudent.externalStudentSemester"/></label>
                                            <Form.Dropdown
                                                search
                                                options={semesterOptions}
                                                value={link.semester}
                                                selection
                                                clearable
                                                placeholder={<FormattedMessage
                                                    id="externalStudent.selectExternalStudentSemester"/>}
                                                onChange={(e, { value }) => {
                                                    this.onChangeLink({ semester: value });
                                                }}
                                                error={errors.semesterErr}
                                            />
                                        </Form.Field>
                                        <Form.Field required>
                                            <label><FormattedMessage id="externalStudent.studyProgram"/></label>
                                            <Form.Dropdown
                                                search
                                                options={studyProgramOptions}
                                                value={link.studyProgram || null}
                                                selection
                                                clearable
                                                placeholder={<FormattedMessage
                                                    id="externalStudent.selectStudyProgram"/>}
                                                onChange={(e, { value }) => this.onChangeLink({ studyProgram: value })}
                                                error={errors.studyProgramErr}
                                            />
                                        </Form.Field>
                                    </Fragment>
                                }
                                {link.mobilityType && link.mobilityType._key === 'non_cycle' &&
                                    <Form.Field required>
                                        <label><FormattedMessage id="externalStudent.nonCycleProgram"/></label>
                                        <Form.Dropdown
                                            search
                                            options={nonCycleProgramOptions}
                                            value={link.nonCycleProgram}
                                            selection
                                            clearable
                                            placeholder={<FormattedMessage id="externalStudent.selectNonCycleProgram"/>}
                                            onChange={(e, { value }) => this.onChangeLink({ nonCycleProgram: value })}
                                            error={errors.nonCycleProgramErr}
                                        />
                                    </Form.Field>
                                }
                            </Form.Group>
                            <Form.Group widths={'equal'}>
                                <Form.Field required>
                                    <label><FormattedMessage id="externalStudent.fieldOfEducation"/>{' '}
                                        <a
                                            className="ui link"
                                            href="https://ec.europa.eu/eurostat/statistics-explained/index.php?title=International_Standard_Classification_of_Education_(ISCED)"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            (<FormattedMessage id={'externalStudent.isced'}/>)
                                        </a>
                                    </label>
                                    <Form.Dropdown
                                        search
                                        options={fieldOfEducationOptions}
                                        value={link.fieldOfEducation}
                                        selection
                                        clearable
                                        placeholder={<FormattedMessage id="externalStudent.selectFieldOfEducation"/>}
                                        onChange={(e, { value }) => this.onChangeLink({ fieldOfEducation: value })}
                                        error={errors.fieldOfEducationErr}
                                    />
                                </Form.Field>
                                <Form.Field error={errors.expiresAtErr}>
                                    <label><FormattedMessage id="externalStudent.expiresAt"/></label>
                                    <FormattedMessage id="externalStudent.enterExpiresAt">
                                        {msg => (
                                            <DateTimePicker
                                                format="D. M. YYYY."
                                                time={false}
                                                placeholder={msg}
                                                value={link.expiresAt ? new Date(link.expiresAt) : null}
                                                onChange={(value) => this.onChangeLink({ expiresAt: value })}
                                            />
                                        )}
                                    </FormattedMessage>
                                </Form.Field>
                                <Form.Field required>
                                    <label><FormattedMessage id="externalStudent.studyType"/></label>
                                    <Form.Dropdown
                                        disabled={true}
                                        search
                                        options={studyTypeOptions}
                                        value={link.studyType}
                                        selection
                                        clearable
                                        placeholder={<FormattedMessage id="externalStudent.selectStudyType"/>}
                                        onChange={(e, { value }) => this.onChangeLink({ studyType: value })}
                                        error={errors.studyTypeErr}
                                    />
                                </Form.Field>
                            </Form.Group>
                            <Button floated={'right'} basic color="blue" disabled={saving} onClick={() => {
                                this.state.onCloseForm();
                            }}>
                                {<FormattedMessage id="externalStudent.cancel"/>}
                            </Button>
                            <Button floated={'right'} color="blue" onClick={this.handleSubmit} loading={saving}>
                                {<FormattedMessage id="externalStudent.confirm"/>}
                            </Button>
                        </Form>
                    </Segment>
                )}
            </Segment>
        );
    }
}

export default RegistrationLinkForm;



// WEBPACK FOOTER //
// ./src/views/ExternalStudents/ExternalStudentRegistrationLink/RegistrationLinkForm.js